import { Vue, newVue } from '@/config/vue'
import store from '@/config/vuex'
import { registerStores } from '@/helpers/stores'
import recommendationsStore, { RECOMMENDATION_BLOCK_IDS } from '@/stores/recommendations'

let initiated = {}
const defaultSelector = '.js-vue-product-recommendations'

const init = data => {
  const identifier = data.identifier || 'current-page'
  if (initiated[identifier] && !data.forceInit) return

  const selector = data.el || data.selector || defaultSelector
  registerStores({ recommendations: recommendationsStore })

  if (!data.skus) {
    const container = document.querySelector('.product-recommendations-container')
    const excludeProductId = Number(container?.dataset.excludeProductId)
    store.dispatch('recommendations/fetchProductPageRecommendations', { excludeProductId })
  } else if (Vue.$dyClient.arrayOfSkusIsValid(data.skus)) {
    store.dispatch('recommendations/fetchProductPageRecommendations', { skus: data.skus })
  } else if (data.generatedByDynamicYield) {
    Vue.$dyClient.trackInvalidRecommendedSkus(data.experimentInfo, data.skus)
  }
  if (data.title) {
    store.commit('recommendations/setHeadline', {
      [RECOMMENDATION_BLOCK_IDS.productPage]: On.helpers.localize(data.title),
    })
  }
  const ProductRecommendations = Vue.component('product-recommendations', () =>
    import(
      /* webpackChunkName: "product-recommendations" */ '@/components/ProductRecommendations/ProductRecommendations.vue'
    )
  )
  newVue({
    render: h =>
      h(ProductRecommendations, {
        props: {
          genderToShow: data.genderToShow || undefined,
          color: data.color || undefined,
        },
      }),
    mount: selector,
  })
  initiated[identifier] = true
}

const initDelayedCallback = () => {
  Vue.$dyClient.delayedCallback(() => init({ selector: defaultSelector }))
}

On.VueInit({
  controller: 'orders',
  action: 'edit',
  init: initDelayedCallback,
})

On.VueInit({
  controller: 'products',
  action: 'show',
  init: initDelayedCallback,
})

window.On.ProductRecommendationsVueInit = init
